import { render, staticRenderFns } from "./ExtendedDate.vue?vue&type=template&id=fe7b3f02&"
import script from "./ExtendedDate.vue?vue&type=script&lang=ts&"
export * from "./ExtendedDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports